var map = {
	"./apple.svg": 82,
	"./beaker.svg": 83,
	"./camera.svg": 84,
	"./cross.svg": 85,
	"./cursor.svg": 86,
	"./dumbbell.svg": 87,
	"./heart.svg": 88,
	"./laptop.svg": 89,
	"./leaf.svg": 90,
	"./lightbulb.svg": 91,
	"./lightning.svg": 92,
	"./microphone.svg": 93,
	"./music.svg": 94,
	"./pawn.svg": 95,
	"./pen.svg": 96,
	"./pencil.svg": 97,
	"./piano.svg": 98,
	"./quote.svg": 32,
	"./smile.svg": 99,
	"./speech.svg": 100
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81;